import { ReactElement } from 'react';

import { styledWithoutTheme as styled } from '../../../../styled';
import { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';
import { Interface } from '../interface';

export const FullscreenIcon = styled((props: Interface): ReactElement => {
	const theme = useTheme();
	return (
		<div {...props}>
			<svg
				width={theme.videoCalls.icons.fullscreenIcon.width}
				height={theme.videoCalls.icons.fullscreenIcon.height}
				viewBox="0 0 24 24"
				fill={theme.videoCalls.icons.fullscreenIcon.backgroundColor}
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M10.8349 14.4443L6.95087 18.3281H9.60938C10.1272 18.3281 10.5469 18.7478 10.5469 19.2656C10.5469 19.7834 10.1272 20.2031 9.60938 20.2031H6.09375C4.80139 20.2031 3.75 19.1517 3.75 17.8594V14.3438C3.75 13.8259 4.16968 13.4062 4.6875 13.4062C5.20532 13.4062 5.625 13.8259 5.625 14.3438V17.0023L9.50885 13.1184C9.87506 12.7522 10.4687 12.7522 10.8347 13.1184C11.2009 13.4844 11.2009 14.0781 10.8349 14.4443ZM19.3125 10.5C19.8303 10.5 20.25 10.0803 20.25 9.5625V6.04688C20.25 4.75452 19.1986 3.70312 17.9062 3.70312H14.3906C13.8728 3.70312 13.4531 4.1228 13.4531 4.64062C13.4531 5.15845 13.8728 5.57812 14.3906 5.57812H17.0491L13.1653 9.46198C12.7991 9.82819 12.7991 10.4218 13.1653 10.7878C13.3482 10.9709 13.5883 11.0625 13.8281 11.0625C14.068 11.0625 14.308 10.9709 14.4911 10.788L18.375 6.90399V9.5625C18.375 10.0803 18.7947 10.5 19.3125 10.5ZM23.0625 16.5C23.5803 16.5 24 16.0803 24 15.5625V3.75C24 1.68219 22.3178 0 20.25 0H3.75C1.68219 0 0 1.68219 0 3.75V20.25C0 22.3178 1.68219 24 3.75 24H20.25C22.3178 24 24 22.3178 24 20.25C24 19.7322 23.5803 19.3125 23.0625 19.3125C22.5447 19.3125 22.125 19.7322 22.125 20.25C22.125 21.2838 21.2838 22.125 20.25 22.125H3.75C2.71619 22.125 1.875 21.2838 1.875 20.25V3.75C1.875 2.71619 2.71619 1.875 3.75 1.875H20.25C21.2838 1.875 22.125 2.71619 22.125 3.75V15.5625C22.125 16.0803 22.5447 16.5 23.0625 16.5Z"
					fill={theme.videoCalls.icons.fullscreenIcon.fill}
				/>
			</svg>
		</div>
	);
})(({ theme }: { theme: Theme }) => theme.videoCalls.icons.fullscreenIcon);
